import { common } from '@/styles/styles';
import { Outcome } from '@/types/api.generated';

/* Standard value used often for paddings and margins */
export const standardValue = common.padding.padding;

export const PICK_TYPE_LABEL = {
    [Outcome.More]: '↑',
    [Outcome.Less]: '↓',
};

export const NFL_FULL_SEASON = 'Full Season';

/* NCPG Phone Number */
export const NCPG_PHONE_NUMBER = '1-800-522-4700';

/* AsyncStorage key that lets automated tests override the selected state */
export const E2E_TESTS_STATE = 'E2E_TESTS_STATE';

export const ANIMATION_SPRING_CONFIG = {
    damping: 20,
    stiffness: 100,
    mass: 1,
};

export const BUNDLE_IDENTIFIER = 'app.instabet.betr';

export const APP_ID = '1635215598';

/* Backoffice top level links */
export const BACKOFFICE_URL_PRODUCTION = 'https://backoffice.betr.app';

// Non-breaking space character (`\u00A0`).
// Unlike a regular space, this Unicode character prevents line breaks at its position.
// In React Native on Android, normal spaces may wrap inconsistently depending on the OS version and text renderer.
// Replacing spaces with NO_BREAK_SPACE ensures text stays on a single line where wrapping should not occur.
export const NO_BREAK_SPACE = '\u00A0';
